module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('data-table', {
    attrs: {
      "title": _vm.type + ' Actions',
      "table-ref": _vm.tableRef,
      "url": '/actions/site/' + _vm.rowData.id + '/' + _vm.type.toLowerCase() + '/',
      "fields": _vm.fields,
      "site-id": _vm.rowData.id,
      "search-placeholder": "Type, Priority, Status...",
      "add-action": _vm.isActive ? _vm.action : null,
      "add-props": _vm.isActive ? _vm.addProps : null,
      "options": _vm.options,
      "detail-component": "action-detail-row"
    },
    scopedSlots: _vm._u([{
      key: "action-type",
      fn: function(props) {
        return [(props.rowData.actionType) ? _c('div', [_c('b', [_vm._v(_vm._s(props.rowData.actionType))])]) : _vm._e(), _vm._v(" "), (props.rowData.actionType === 'ACTIVE') ? _c('el-button', {
          ref: "act",
          attrs: {
            "size": "small",
            "type": "primary",
            "disable": !_vm.isManager('project|management'),
            "icon": "fa fa-check-circle"
          },
          on: {
            "click": function($event) {
              return _vm.siteActive(props.rowData.id, $event)
            }
          }
        }, [_vm._v(" Make Active\n         ")]) : _vm._e(), _vm._v(" "), (props.rowData.actionType === 'DISMANTLE') ? _c('el-button', {
          ref: "dis",
          attrs: {
            "size": "small",
            "type": "danger",
            "disable": !_vm.isManager('project|management'),
            "icon": "fa fa-trash-alt"
          },
          on: {
            "click": function($event) {
              return _vm.siteDismantle(props.rowData.id, $event)
            }
          }
        }, [_vm._v(" Set Dismantled\n          ")]) : _vm._e(), _vm._v(" "), (props.rowData.actionType === 'COMPLAINT') ? _c('ticket-action', {
          ref: "tic",
          attrs: {
            "showText": true,
            "row-data": props.rowData,
            "size": "small",
            "site-id": _vm.siteId,
            "org-id": props.rowData.organisation_id,
            "ticket-id": props.rowData.ticket_id
          }
        }) : _vm._e()]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [_c('el-row', {
          attrs: {
            "gutter": 12
          }
        }, [_c('el-col', {
          attrs: {
            "span": 16,
            "align": "left"
          }
        }, [_c('contacts-popover', {
          attrs: {
            "row-data": _vm.rowData
          }
        })], 1), _vm._v(" "), (_vm.isManager('management')) ? _c('el-col', {
          attrs: {
            "span": 4,
            "align": "right"
          }
        }, [_c('el-button', {
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": "fa fa-trash-alt",
            "circle": "",
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteEntry(props.rowData)
            }
          }
        })], 1) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a3dddd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/ActionsTable.vue
// module id = 1428
// module chunks = 0